import { render, staticRenderFns } from "./PermissionHelperModal.vue?vue&type=template&id=8c36199a&"
import script from "./PermissionHelperModal.vue?vue&type=script&lang=ts&"
export * from "./PermissionHelperModal.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionHelperModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports